import styled from "styled-components";
import {BaseModalForm} from "./modalStyle";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import SendFormButton from "../buttons/SendFormButton";
import ExitButton from "../buttons/ExitButton";
import {patchProject} from "../project/one-project/projectAction";
import FormikControl from "../inputs/FormikControl";
import {FunctionalModal} from "./FunctionalModal";

const WeatherModal = ({setIsOpen}) => {

    const {id, weather} = useSelector(state => state.project)
    const [selectedWeather, setSelectedWeather] = useState(weather)

    const dispatch = useDispatch()

    const handleChange = (e) => {
        const {value} = e.target;
        setSelectedWeather(value);
    }


    const closeModal = () => {
        setIsOpen(false)
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        const data = {
            weather: selectedWeather
        }
        dispatch(patchProject(id, data));
        setTimeout(() => setIsOpen(false), 1000)

    }

    const displayModal = () => {
        return (
            <Modal
                onSubmit={handleSubmit}>
                <ExitButton
                    closeUpdate={closeModal}/>
                <FormikControl
                    control={"weather"}
                    name={"weather"}
                    label={"Choisir une météo"}
                    handleChange={handleChange}
                    selectedWeather={selectedWeather}
                />
                <SendFormButton
                    state={true}
                    actionName={"Enregistrer"}
                />
            </Modal>
        )
    }
    return (

        <FunctionalModal component={displayModal()} setOpen={setIsOpen}/>

    )
}

const Modal = styled(BaseModalForm)`
  width: 20rem;
  height: fit-content;
  padding: 2rem;
  inset: 0;
  left: 0;
  right: 0;
  margin: auto;

  h1 {
    text-align: center;
  }

  .exit-btn {
    align-self: flex-end;
  }

  @media (min-width: 900px) {
    width: 40rem;
  }
`
export default WeatherModal;